export default __webpack_public_path__ + "static/Homepage_Map_23_Offices_041024_Transparent-9c13c8de993b4d2a7617636193a4dfc5.webp";